export const enum SessionStorageKey {
  LatestPaxConfig = 'pax',
}
